<template>
  <v-container>
    <v-card>
      <v-card-title class="headline font-weight-bold"
        >Политика конфиденциальности и обработки персональных
        данных</v-card-title
      >
      <v-card-text>
        <p>
          Настоящая политика конфиденциальности регулирует порядок обработки и
          защиты персональных данных пользователей сайта
          <a href="mailto:https://up-mind.ru">https://up-mind.ru</a> и личного
          кабинета партнёров по адресу
          <a href="https://account.up-mind.ru">https://account.up-mind.ru</a>,
          принадлежащих Обществу с ограниченной ответственностью «Апмайнд+» (ИНН
          7802940442, ОГРН 1237800058352, далее — «Оператор»).
        </p>

        <h2>1. Общие положения</h2>
        <p>
          1.1. Настоящая Политика разработана в соответствии с требованиями
          Федерального закона № 152-ФЗ «О персональных данных» и иными
          нормативными актами Российской Федерации.
        </p>
        <p>
          1.2. Использование сайта и/или личного кабинета означает безусловное
          согласие пользователя с настоящей Политикой и условиями обработки его
          персональных данных.
        </p>
        <p>
          1.3. В случае несогласия с условиями Политики пользователь должен
          воздержаться от использования сайта и предоставления своих данных.
        </p>

        <h2>2. Состав собираемых данных</h2>
        <p>
          Оператор может обрабатывать следующие категории персональных данных:
        </p>
        <ul>
          <li>фамилия, имя;</li>
          <li>адрес электронной почты;</li>
          <li>номер телефона;</li>
          <li>возраст (количество полных лет);</li>
          <li>
            данные об использовании курсов (прогресс, время просмотра и
            активность);
          </li>
          <li>
            технические данные (IP-адрес, cookies, информация о браузере и
            устройстве).
          </li>
        </ul>

        <h2>3. Цели обработки персональных данных</h2>
        <p>
          Персональные данные пользователей обрабатываются в следующих целях:
        </p>
        <ul>
          <li>регистрация и предоставление доступа к курсам UpMIND+;</li>
          <li>
            создание и обслуживание личных кабинетов партнёров и их клиентов;
          </li>
          <li>
            консультирование пользователей и партнёров, обратная связь по
            заявкам;
          </li>
          <li>информирование об акциях, новых продуктах и обновлениях;</li>
          <li>улучшение качества работы сайта и пользовательского опыта;</li>
          <li>
            выполнение обязанностей, предусмотренных законодательством
            Российской Федерации.
          </li>
        </ul>

        <h2>4. Правовые основания обработки</h2>
        <p>Обработка персональных данных осуществляется на основании:</p>
        <ul>
          <li>согласия субъекта персональных данных;</li>
          <li>
            заключения и исполнения договора между пользователем и Оператором;
          </li>
          <li>исполнения обязанностей, предусмотренных законом.</li>
        </ul>

        <h2>5. Порядок обработки персональных данных</h2>
        <p>
          5.1. Обработка персональных данных включает сбор, запись,
          систематизацию, хранение, уточнение, использование, передачу (в том
          числе партнёрам Оператора), обезличивание, блокирование и уничтожение
          данных.
        </p>
        <p>
          5.2. Передача данных третьим лицам допускается только в целях,
          указанных в разделе 3, и при условии соблюдения требований
          законодательства РФ о защите персональных данных.
        </p>
        <p>
          5.3. Оператор принимает необходимые организационные и технические меры
          для защиты персональных данных от неправомерного доступа, уничтожения,
          изменения, блокирования, копирования и распространения.
        </p>

        <h2>6. Сроки обработки и хранения персональных данных</h2>
        <p>
          6.1. Персональные данные хранятся в течение всего срока действия
          договора (оказания услуг) и не более 3 лет после его завершения, если
          иное не установлено законом.
        </p>
        <p>
          6.2. По истечении срока хранения данные подлежат удалению или
          обезличиванию.
        </p>

        <h2>7. Права субъекта персональных данных</h2>
        <p>Пользователь имеет право:</p>
        <ul>
          <li>получать информацию об обработке своих данных;</li>
          <li>требовать уточнения, блокирования или удаления данных;</li>
          <li>
            отозвать согласие на обработку персональных данных, направив
            уведомление на адрес электронной почты Оператора:
            <b>info@up-mind.ru</b>.
          </li>
        </ul>

        <h2>8. Ответственность</h2>
        <p>
          Оператор несёт ответственность за соблюдение требований
          законодательства РФ в области персональных данных. В случае утраты или
          разглашения данных Оператор уведомляет пользователя об этом факте.
        </p>

        <h2>9. Контактная информация Оператора</h2>
        <p>
          Оператор: Общество с ограниченной ответственностью «Апмайнд+»<br />
          ИНН: 7802940442<br />
          ОГРН: 1237800058352<br />
          Адрес: г. Санкт-Петербург<br />
          Электронная почта: <b>info@up-mind.ru</b>
          <br />
          Ответственный за обработку персональных данных: генеральный директор
          Терентьев Юрий Михайлович
        </p>

        <h2>10. Заключительные положения</h2>
        <p>
          10.1. Оператор вправе вносить изменения в настоящую Политику без
          предварительного уведомления пользователей.
        </p>
        <p>
          10.2. Новая редакция Политики вступает в силу с момента её размещения
          на сайте.
        </p>
        <p>
          10.3. Действующая редакция Политики постоянно доступна по адресу:
          <a href="https://up-mind.ru/privacy">https://up-mind.ru/privacy</a>.
        </p>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "PrivacyPolicyView",
};
</script>

<style scoped>
.v-card {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
}
.v-card__text {
  line-height: 1.6;
}
h2 {
  margin-top: 24px;
  margin-bottom: 12px;
  color: #000000;
}
</style>
